module.exports = __webpack_public_path__ + "4f564472dd4834912c444b9097205a3a.gif";


//////////////////
// WEBPACK FOOTER
// ./public/img/movie-icons/01_icon_project_new.gif
// module id = 686
// module chunks = 0